import { ServiceAttachModel } from '@klant/conversational-connector/models/ServiceAttach.model';
import { ConversationalConnectorAnalyticsService } from '@klant/conversational-connector/services/analytics/analytics.service';
import { WebsocketService } from '@klant/conversational-connector/services/wsservice/websocket.service';

import { inject, Injectable } from '@angular/core';

import { ConversationalChatStore } from '../../../../signal-stores/conversational-chat-store/conversational-chat.store';

@Injectable({ providedIn: 'root' })
export class InactivityService {
    private readonly analyticsService = inject(ConversationalConnectorAnalyticsService);
    private readonly chatStore = inject(ConversationalChatStore);
    private readonly webSocketService = inject(WebsocketService);

    public handleServiceAttach(serviceAttach: ServiceAttachModel): void {
        if (serviceAttach.serviceName === 'bot') {
            this.chatStore.setShowLiveChatFaqPopUp(false);
        }
    }

    public promptContinue(): void {
        this.analyticsService.clickEvent('Inactivity button', 'Doorgaan');
        this.webSocketService.continueConversationAfterIdle();
        this.chatStore.setIdleTimerActive(false);
    }

    public promptEnd(): void {
        this.analyticsService.clickEvent('Inactivity button', 'Beëindigen');
        this.webSocketService.endConversationAfterIdle();
        this.chatStore.setIdleTimerActive(false);
    }
}
